import { makeAutoObservable, runInAction } from 'mobx'
import { IUserPhoto } from '../models/user_model'
import { API } from '../services/api'
import { WorkspacesStore } from './WorkspaceStore'

export type FilesData = Array<IUserPhoto>
const START_PAGE = 0
const PHOTOS_PER_PAGE = 20

export class PhotosStore {
  private _callacks: Array<Function> = []
  photos: IUserPhoto[] = []
  currentPage = START_PAGE
  photosPerPage = PHOTOS_PER_PAGE
  isFetching = false
  isRefetching = false
  allFetched = false
  isInitialized = false
  tag: string | undefined = undefined
  albumId: string | undefined = undefined

  constructor(public readonly workspaceStore: WorkspacesStore) {
    makeAutoObservable(this)
  }

  reset = () => {
    this.photos = []
    this.isFetching = false
    this.isRefetching = false
    this.allFetched = false
    this.isInitialized = false
    this.tag = undefined
  }

  addOnNewPhotosFetchCallback = (callback: Function) => {
    this._callacks.push(callback)
  }

  removeOnNewPhotosFetchCallback = (callback: Function) => {
    this._callacks = this._callacks.filter((c) => c !== callback)
  }

  private _callCallbacks() {
    for (const callback of this._callacks) callback()
  }

  setPhotos = (photos: Array<IUserPhoto>) => {
    this.photos = photos
  }

  addPhotos = (photos: Array<IUserPhoto>) => {
    this.photos = [...this.photos, ...photos]
  }

  setIsFetching = (isFetching: boolean) => {
    this.isFetching = isFetching
  }

  setIsRefetching = (isRefetching: boolean) => {
    this.isRefetching = isRefetching
  }

  fetchPhotos = async (
    page: number = 0,
    perPage: number = 20,
    tag?: string,
    albumId?: string
  ) => {
    if (this.isRefetching || this.isFetching) return
    this.allFetched = false
    this.currentPage = page
    this.tag = tag
    this.albumId = albumId
    this.photosPerPage = perPage
    if (!this.isInitialized) this.isInitialized = true
    this.setIsFetching(true)
    const { data, status } = await API.getInstance().fetchPhotos({
      workspaceId: this.workspaceStore.activeWorkspaceId,
      page,
      perPage,
      tag,
      albumId,
    })
    if (status === 200) {
      this.setPhotos(data)
      // TODO
      this._callCallbacks()
    }
    this.setIsFetching(false)
  }

  fetchNextPage = async () => {
    if (this.allFetched || this.isRefetching || this.isFetching) return
    this.isRefetching = true
    const { data, status } = await API.getInstance().fetchPhotos({
      workspaceId: this.workspaceStore.activeWorkspaceId,
      page: ++this.currentPage,
      perPage: this.photosPerPage,
      tag: this.tag,
    })
    if (status === 200) {
      if (data.length < this.photosPerPage) {
        this.allFetched = true
      }
      this.addPhotos(data)
    }
    this.setIsRefetching(false)
  }
}
